import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

// Provides top navigation bar for mobile devices with dynamic menu items from backend.
// Also handles mobile menu toggle and click outside to close.
export default function TopNav() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const path = location.pathname;
  const [topMenuItems, setTopMenuItems] = useState([]);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/menu-items/top-menu`)
      .then(res => res.json())
      .then(data => setTopMenuItems(data))
      .catch(console.error);
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      alert("see if clicked outside mobile menu...");
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        alert("clicked outside mobile menu, closing menu");
        setMenuOpen(false);
      }
    };
    if (menuOpen) document.addEventListener("mousedown", handleClickOutside);
    else document.removeEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [menuOpen]);

  // Helper to build href for dynamic content pages
  const makeHref = (item) => item.url || `/content/${item.code}`;

  const isActive = (target) => path === target ? "active-link" : "";
  return (
    <>
      <nav className="mobile-menu " id="mobileMenu">
        <button
          className="menu-close"
          onClick={() => toggleMobileMenu()}
          aria-label="Close menu"
        >
          ×
        </button>
        <a href="/" className={isActive("/")}>Home</a>
        <a href={`https://www.strava.com/oauth/authorize?client_id=${process.env.REACT_APP_STRAVA_CLIENT_ID}&response_type=code&redirect_uri=${process.env.REACT_APP_FRONTEND_URL}/&scope=read,activity:read_all`}>
          Aanmelden
        </a>
        {topMenuItems.map(item => (
          <a key={`mobile-menu-${item.code}`} href={makeHref(item)}>
            {item.title}
          </a>
        ))}
      </nav>
    </>
  );
}